import { render } from "./ScoreCard.vue?vue&type=template&id=8675ee1c&scoped=true"
import script from "./ScoreCard.vue?vue&type=script&lang=js"
export * from "./ScoreCard.vue?vue&type=script&lang=js"

import "./ScoreCard.vue?vue&type=style&index=0&id=8675ee1c&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8675ee1c"]])

export default __exports__